<template>
  <div class="comp-wrapper">
    <div class="comp-main">
      <div class="paper-order-box">
        <div class="paper-order-item van-hairline--bottom"
             v-for="(item, index) in examPaperModules"
             :key="index">
          <div class="paper-order-item-title">{{ item.moduleName }}</div>
          <div class="paper-order-item-content">
            <van-tag class="order-tag"
                     v-for="(question, questIndex) in item.questions"
                     :key="questIndex"
                     size="large"
                     :type="action === 'do' ? (hasAnswer(question) ? 'primary' : undefined) : answerResultType(question)"
                     @click="handleTagClick(question)">{{ question.itemOrder }}</van-tag>
          </div>
        </div>
      </div>
    </div>
    <div class="comp-btn-box van-hairline--top">
      <van-button @click="handleClose">关 闭</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaperOrder',
  props: {
    dialogParams: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      action: 'do', // do:考试；view:查看
      examPaperModules: []
    }
  },
  computed: {
    // 是否有答案
    hasAnswer() {
      return function (question) {
        // 1-单选、3-判断、5-简答的答案为correct字符串。2-多选、4-填空的答案为correctArray数组。
        const { questionType, correct, correctArray } = question;
        // 单选、判断、简答
        if (questionType == 1 || questionType == 3 || questionType == 5) {
          return correct ? true : false;
        } else if (questionType == 2) {
          // 多选
          return correctArray && correctArray.length > 0 ? true : false;
        } else if (questionType == 4) {
          // 填空，需要判断每个空是否为空
          for (let i = 0; i < correctArray.length; i++) {
            if (!correctArray[i]) {
              return false;
            }
          }
          if (!correctArray.length) {
            return false;
          }
          return true;
        }
        return false;
      };
    },
    // 答案结果类型
    answerResultType() {
      return function (question) {
        if (!question.answer) return 'danger'
        return question.answer.answerResult == 1 ? 'success' : 'danger'
      }
    }
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      const { examPaperModules, action } = this.dialogParams
      this.examPaperModules = examPaperModules
      this.action = action
    },
    handleTagClick(question) {
      let currentIndex = question.itemOrder - 1
      this.$emit('confirm', { currentIndex });
    },
    handleClose() {
      this.$emit('close');
    }
  },
}
</script>

<style lang="less" scoped>
.comp-wrapper {
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.comp-main {
  height: calc(100% - 56px);
  padding: 10px;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  .paper-order-box {
    overflow-y: auto;
    .paper-order-item {
      padding: 12px 0;
    }
    .paper-order-item-title {
      font-weight: 600;
    }
    .paper-order-item-content {
      display: inline-flex;
      flex-wrap: wrap;
      .order-tag {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 39px;
        height: 39px;
        margin-right: 10px;
        margin-top: 6px;
        box-sizing: border-box;
      }
    }
  }
}
.comp-btn-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 56px;
  background-color: #fff;
}
</style>